export const accCheckerMenuItemText = "ffHEOb";
export default {accCheckerMenuItemText};